import React from 'react';
import { Link } from 'react-router-dom';
import Sidebar from '../mendepartmentdetails/Sidebar';
import SubDeptImage from '../../../assets/image/department/group-young-people-working-together-project_23-2148461544.jpg';

function FamilySupportWelfare() {
  return (
    <section className="department-details-section">
      <div className="container">
        <div className="row">

          {/* Sidebar */}
          <div className="col-12 col-lg-4 col-xl-4">
            <Sidebar />
          </div>

          {/* Main Content */}
          <div className="col-lg-8">
            <div className="department-details-imgbox">
              <img src={SubDeptImage} className="img-fluid" alt="Family Support and Welfare Assistance" />
            </div>

            <div className="department-details-content-box">
              <h4 className="department-details-title">Family Support and Welfare Assistance</h4>
              <p>
                This sub-department is focused on providing critical resources and assistance to families in need. 
                Services include food assistance, temporary housing, and financial aid to help families achieve stability and security.<br /><br />
                By offering these essential services, we aim to support vulnerable populations and foster stronger family units.
              </p>
            </div>

            <div className="department-details-benefits-box">
              <h3>Key Services</h3>
              <ul className="list-unstyled list-style">
                <li>
                  <i className="fa-solid fa-circle-arrow-right" />
                  <h5>Food and Nutritional Assistance</h5>
                </li>
                <li>
                  <i className="fa-solid fa-circle-arrow-right" />
                  <h5>Temporary Housing Programs</h5>
                </li>
                <li>
                  <i className="fa-solid fa-circle-arrow-right" />
                  <h5>Financial Aid for Families</h5>
                </li>
              </ul>
            </div>

            <div className="department-details-policy-box">
              <h4>Our Commitment:</h4>
              <p>
                We are committed to ensuring that families in need have access to the resources and support necessary to build a stable and secure future.
              </p>
            </div>
            <div>
              <Link to="/department/family-services">
              <i className="fa-solid fa-circle-arrow-left" style={{ marginRight: '5px' }}/>
              Go Back
              </Link>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}

export default FamilySupportWelfare;
